var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ignoreFields.includes(_vm.item.field)
    ? _c(
        "div",
        [_vm._t("default", null, { data: _vm.item, index: _vm.index })],
        2
      )
    : _vm.item.form_type == "text"
    ? _c("el-input", {
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          maxlength: 100,
          placeholder: _vm.item.placeholder,
          type: _vm.item.form_type,
        },
        on: {
          input: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.isTrimInput(_vm.item.form_type)
    ? _c("el-input", {
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          "prefix-icon": _vm.getInputIcon(_vm.item.form_type),
          maxlength: _vm.getInputMaxlength(_vm.item.form_type),
          placeholder: _vm.item.placeholder,
          type: "text",
        },
        on: {
          input: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(
              _vm.fieldFrom,
              _vm.item.field,
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "number"
    ? _c("el-input-number", {
        attrs: {
          placeholder: _vm.item.placeholder,
          disabled: _vm.item.disabled || _vm.disabled,
          controls: false,
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "floatnumber"
    ? _c("el-input-number", {
        attrs: {
          placeholder: _vm.item.placeholder,
          disabled: _vm.item.disabled || _vm.disabled,
          controls: false,
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "percent"
    ? _c("wk-percent-input", {
        attrs: {
          placeholder: _vm.item.placeholder,
          disabled: _vm.item.disabled || _vm.disabled,
          controls: false,
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "textarea"
    ? _c("el-input", {
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          rows: 3,
          autosize: { minRows: 3 },
          maxlength: _vm.item.maxlength || 800,
          placeholder: _vm.item.placeholder,
          type: _vm.item.form_type,
          resize: "none",
        },
        on: {
          input: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : ["select"].includes(_vm.item.form_type)
    ? _c("wk-select", {
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          clearable: _vm.item.clearable,
          placeholder: _vm.item.placeholder,
          options: _vm.item.setting,
          "show-type": _vm.item.precisions === 1 ? "tiled" : "default",
          "other-show-input": _vm.item.hasOwnProperty("optionsData"),
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : ["checkbox"].includes(_vm.item.form_type)
    ? _c("wk-checkbox", {
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          clearable: _vm.item.clearable,
          placeholder: _vm.item.placeholder,
          options: _vm.item.setting,
          "show-type": _vm.item.precisions === 1 ? "tiled" : "default",
          "other-show-input": _vm.item.hasOwnProperty("optionsData"),
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "date"
    ? _c("el-date-picker", {
        staticStyle: { width: "100%" },
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          clearable: "",
          type: "date",
          "value-format": "yyyy-MM-dd",
          placeholder: "选择日期",
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "dateRange"
    ? _c("el-date-picker", {
        staticStyle: { width: "100%", "vertical-align": "middle" },
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          type: _vm.item.dateType || "daterange",
          "value-format": _vm.item.dateValueFormat || "yyyy-MM-dd",
          clearable: "",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "datetime"
    ? _c("el-date-picker", {
        staticStyle: { width: "100%" },
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          clearable: "",
          type: "datetime",
          "value-format": "yyyy-MM-dd HH:mm:ss",
          placeholder: "选择日期",
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "structure"
    ? _c("wk-dep-select", {
        staticStyle: { width: "100%" },
        attrs: {
          request: _vm.item.request,
          props: _vm.item.props,
          params: _vm.item.params,
          disabled: _vm.item.disabled || _vm.disabled,
          radio: !_vm.isEmptyValue(_vm.item.radio) ? _vm.item.radio : true,
        },
        on: {
          change: function ($event) {
            return _vm.depOrUserChange(
              _vm.item,
              _vm.index,
              arguments[0],
              arguments[1]
            )
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : ["single_user", "user"].includes(_vm.item.form_type)
    ? _c("wk-user-select", {
        staticStyle: { width: "100%" },
        attrs: {
          request: _vm.item.request,
          props: _vm.item.props,
          params: _vm.item.params,
          disabled: _vm.item.disabled || _vm.disabled,
          radio: !_vm.isEmptyValue(_vm.item.radio) ? _vm.item.radio : true,
        },
        on: {
          change: function ($event) {
            return _vm.depOrUserChange(
              _vm.item,
              _vm.index,
              arguments[0],
              arguments[1]
            )
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "radio"
    ? _c(
        "el-radio-group",
        {
          attrs: {
            disabled: _vm.item.disabled || _vm.disabled,
            placeholder: _vm.item.placeholder,
          },
          on: {
            change: function ($event) {
              return _vm.commonChange(_vm.item, _vm.index, $event)
            },
          },
          model: {
            value: _vm.fieldFrom[_vm.item.field],
            callback: function ($$v) {
              _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
            },
            expression: "fieldFrom[item.field]",
          },
        },
        _vm._l(_vm.item.setting, function (item, index) {
          return _c(
            "el-radio",
            {
              key: index,
              attrs: {
                label: !_vm.isEmptyValue(item.value) ? item.value : item,
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    !_vm.isEmptyValue(item.value)
                      ? item.label || item.name
                      : item
                  ) +
                  "\n  "
              ),
            ]
          )
        }),
        1
      )
    : _vm.item.form_type == "boolean_value"
    ? _c("el-switch", {
        attrs: {
          disabled: _vm.item.disabled || _vm.disabled,
          "active-value": "1",
          "inactive-value": "0",
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "position"
    ? _c("wk-position", {
        attrs: {
          "hide-area": _vm.item.hideArea,
          "only-province": _vm.item.onlyProvince,
          "show-detail": _vm.item.showDetail,
          disabled: _vm.item.disabled || _vm.disabled,
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "location"
    ? _c("wk-location", {
        attrs: { disabled: _vm.item.disabled || _vm.disabled },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "handwriting_sign"
    ? _c("wk-signature-pad", {
        attrs: { disabled: _vm.item.disabled || _vm.disabled },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "desc_text"
    ? _c("wk-desc-text", { attrs: { value: _vm.fieldFrom[_vm.item.field] } })
    : _vm.item.form_type === "date_interval"
    ? _c("el-date-picker", {
        staticStyle: { width: "100%", "vertical-align": "middle" },
        attrs: {
          type: _vm.item.dateType || "daterange",
          "value-format": _vm.item.dateValueFormat || "yyyy-MM-dd",
          disabled: _vm.item.disabled || _vm.disabled,
          clearable: "",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
        },
        on: {
          change: function ($event) {
            return _vm.commonChange(_vm.item, _vm.index, $event)
          },
        },
        model: {
          value: _vm.fieldFrom[_vm.item.field],
          callback: function ($$v) {
            _vm.$set(_vm.fieldFrom, _vm.item.field, $$v)
          },
          expression: "fieldFrom[item.field]",
        },
      })
    : _vm.item.form_type == "address"
    ? _c("v-distpicker", {
        attrs: {
          province: _vm.fieldFrom[_vm.item.field].province,
          city: _vm.fieldFrom[_vm.item.field].city,
          area: _vm.fieldFrom[_vm.item.field].area,
        },
        on: {
          province: function ($event) {
            return _vm.selectProvince($event, _vm.item, _vm.index)
          },
          city: function ($event) {
            return _vm.selectCity($event, _vm.item, _vm.index)
          },
          area: function ($event) {
            return _vm.selectArea($event, _vm.item, _vm.index)
          },
        },
      })
    : _vm.item.form_type == "file"
    ? _c("xh-files", {
        attrs: {
          value: _vm.fieldFrom[_vm.item.field],
          disabled: _vm.item.disabled || _vm.disabled,
        },
        on: {
          "value-change": function ($event) {
            return _vm.oldChange($event, _vm.item, _vm.index)
          },
        },
      })
    : _vm.item.form_type == "detail_table"
    ? _c("wk-detail-table", {
        attrs: {
          "show-type": _vm.item.precisions === 2 ? "table" : "default",
          title: _vm.item.name,
          "prop-prefix": _vm.item.field,
          "btn-name": _vm.item.remark,
          "add-field-list": _vm.item.fieldExtendList,
          "add-field-form": _vm.item.fieldForm,
          "field-form": _vm.fieldFrom[_vm.item.field],
          "field-list": _vm.item.fieldList,
          disabled: _vm.item.disabled || _vm.disabled,
        },
      })
    : _c(
        "div",
        [_vm._t("default", null, { data: _vm.item, index: _vm.index })],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }